import React, { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { default as TariffSidebar } from "../components/Sidebar"
import Config from "./SidebarConfig"
import * as faIcons from "react-icons/fa"

const SidebarMenuItem = (props) => {
  let IconComponent = faIcons[props.icon]
  if (!IconComponent) {
    IconComponent = faIcons.FaQuestionCircle
  }
  return (
    <div
      className={`h-9 px-3 py-2 flex justify-start items-center gap-2 rounded-md ${
        props.selected ? "bg-gray-200" : ""
      }`}
    >
      <div className="flex items-center gap-2">
        <div className="w-5 h-5 flex justify-center items-center">
          <IconComponent />
        </div>
        <div className="text-gray-800 whitespace-nowrap text-sm font-medium font-['Inter'] leading-tight tracking-tight">
          {props.title}
        </div>
      </div>
    </div>
  )
}

const Sidebar = () => {
  const router = useRouter()
  const [config, setConfig] = useState()

  useEffect(() => {
    const currRoute = router.pathname.split("/")
    let confName = Object.keys(Config).find((c) => currRoute.includes(c))
    setConfig(Config[confName])
  }, [router.pathname])

  if (["create-tariff", "/charger", "/site/", "/sites", "/schedules"].find((r) => router.pathname.includes(r))) {
    return <TariffSidebar highlight={""} />
  }

  return config ? (
    <div className="hidden sm:block p-4 min-w-fit min-h-screen text-gray-800 bg-white border-r border-gray-200 flex flex-col gap-4 overflow-y-auto">
        {config && (
          <>
            <div className="text-gray-800 whitespace-nowrap text-lg font-semibold">
              {config?.title}
            </div>
            <div>
              {config?.routes.map((r, i) => (
                <div
                  key={i}
                  className="cursor-pointer"
                  onClick={() => router.push(r.route)}
                >
                  <SidebarMenuItem title={r.label} icon={r.icon} selected={router.pathname === r.route} />
                </div>
              ))}
            </div>
          </>
        )}
    </div>
  ) : null
}

export default Sidebar
